import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
const SvgRatedGood = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 15 14",
	...props,
	children: /* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsx("path", {
		fill: "#ffffff",
		fillOpacity: 0,
		d: "M0-1h16v16H0z"
	}), /* @__PURE__ */ _jsx("path", {
		fill: "inherit",
		d: "M0 13.333h2.667v-8H0v8zM14.667 6c0-.733-.6-1.333-1.334-1.333H9.127L9.76 1.62l.02-.213c0-.274-.113-.527-.293-.707L8.78 0 4.393 4.393c-.246.24-.393.574-.393.94V12c0 .733.6 1.333 1.333 1.333h6c.554 0 1.027-.333 1.227-.813l2.013-4.7c.06-.153.094-.313.094-.487V6.06l-.007-.007.007-.053z"
	})] })
});
export default SvgRatedGood;
